import { getProject } from '~/api/projects';

export default defineNuxtRouteMiddleware(async (to) => {
  const projectId = to.params.id?.toString();
  if (!projectId || isNaN(Number(projectId))) return;

  const project = await getProject(projectId);

  if (project?.slug) {
    return navigateTo(`/projects/${project.slug}`, { redirectCode: 301 });
  }
});
